//import { head } from 'ramda';

export const actionsAlpha = ({ set, get }) => ({
    setAsyncRequest:        () => {
        const num = get('isAsyncRequest');
        set('isAsyncRequest', num + 1);
    },
    unsetAsyncRequest:      () => {
        const num = get('isAsyncRequest');
        set('isAsyncRequest', num - 1 < 0 ? 0 : num - 1);
    },
})

export const actionsBeta = ({ set, get }) => ({
    setAuthData: ({ userData, token }) => {
        set('state', (draft) => {
            draft.userData = userData;
            draft.token = token;
            return draft;
        });
    },
    doLogout: () => {
        set('state', (draft) => {
            draft.userData = {};
            draft.token = '';
            return draft;
        });
    }
});
